import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { getPartners } from '../../../../api/ApiEndpoints';
import { useEffect, useState } from 'react';
import { BDSMForm } from '../../../../components/form/BDSMForm';
import { useAlert } from 'react-alert';
import { CreateButton } from '../../../../components/buttons/CreateButton';
import Modal from 'react-bootstrap/Modal';
import React from 'react';
import { getAllProductsList } from '../product/ProductService';
import {
    minNumber,
    minPrice, minStringNumber,
    notLaterThan
} from '../../../../validations/Validators';
import { DEFAULT_DATE_TIME } from '../../../../components/common/Constants';
import { toDateString } from '../../../../utils/TimeUtils';

const WarehouseForm = ({ onClick, onCancel, record }) => {
    const { t } = useTranslation('warehouse');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const alert = useAlert();
    let isEditing = record.id !== -1;
    const [products, setProducts] = useState([{ name: t('common:SELECT'), value: -1 }]);
    const [partners, setPartners] = useState([{ name: t('common:SELECT'), value: -1 }]);

    const validation = Yup.object().shape({
        productId:  Yup.number().min(0, t('validations:required')),
        invoice: Yup.string().required(t('validations:required')),
        invoiceDate: Yup.string()
            .transform(value => (value === null ? '' : value))
            .required(t('validations:required')),
        partnerId: minNumber(0, t),
        price: minPrice(0.01, t).required(t('validations:required')),
        amount: minStringNumber(0, t).required(t('validations:required')),
        expiredDate: notLaterThan(new Date(), t)
    });

    useEffect(() => {
        getAllProductsList()
            .then((response) => setProducts(products.concat(
                response.data.map(it => ({ name: it.title, value: it.id })),
            )))
            .catch(() => alert.error(t('alert:loadingError')));
        getPartners()
            .then((response) => setPartners(partners.concat(
                response.data.map(it => ({ name: it.partnerName, value: it.id })),
            )))
            .catch(() => alert.error(t('alert:loadingError')));
    }, []);

    const handleSubmit = (values) => {
        let result = {
            ...values,
            expiredDate: toDateString(values.expiredDate, DEFAULT_DATE_TIME),
            invoiceDate: toDateString(values.invoiceDate, DEFAULT_DATE_TIME)
        }
        onClick(result, record.id);
        onClose();
    };

    const onClose = () => {
        onCancel();
        handleClose();
    };

    const getFormModel = () => {
        let datePicker = {
            dateFormat: DEFAULT_DATE_TIME,
            showTime: true,
            timeFormat: 'HH:mm',
            timeIntervals: '15',
        };
        return {
            initValues: record,
            onSubmit: (record) => handleSubmit(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ['productId', 'invoice', 'invoiceDate', 'partnerId', 'price', 'amount', 'expiredDate'],
            types: ['searchSelect', 'text', 'datePicker', 'select', 'number', 'number', 'datePicker'],
            className: 'mb-3',
            label: [
                t('productName'),
                t('invoice'),
                t('invoiceDate'),
                t('supplier'),
                t('price'),
                t('amount'),
                t('expiredDate'),
            ],
            selectData: [products, null, datePicker, partners, null, null, datePicker],
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <CreateButton onClick={handleShow} />
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? t('updateRecord') : t('newRecord')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default WarehouseForm;
